import { AppThunk } from "../../store";
import { bookingActions } from "./bookingSlice";
import { apiFetch } from "../../../utils/api";
import { toPage, withPaging } from "../../../utils/pagination";
import { BookingRequest, BookingResponse } from "../../../types/bookingTypes";

export const createBooking =
  (payload: BookingRequest): AppThunk<Promise<BookingResponse | null>> =>
  async (dispatch) => {
    try {
      dispatch(bookingActions.startLoading());
      const data: BookingResponse = await apiFetch(
        "/api/bookings",
        { method: "POST", body: JSON.stringify(payload) },
        true
      );
      dispatch(bookingActions.upsertBooking(data));
      return data;
    } catch (e: any) {
      dispatch(bookingActions.setError(e.message));
      return null;
    } finally {
      dispatch(bookingActions.endLoading());
    }
  };

export const fetchBookingsByCustomer =
  (customerId: number, page: number = 0): AppThunk =>
  async (dispatch) => {
    try {
      dispatch(bookingActions.startLoading());
      const data = await apiFetch(
        withPaging(`/api/bookings/customer/${customerId}`, page),
        {},
        true
      );
      dispatch(bookingActions.setBookingsPage(toPage(data)));
    } catch (e: any) {
      dispatch(bookingActions.setError(e.message));
    } finally {
      dispatch(bookingActions.endLoading());
    }
  };

export const fetchBookingsByHandyman =
  (handymanId: number, page: number = 0): AppThunk =>
  async (dispatch) => {
    try {
      dispatch(bookingActions.startLoading());
      const data = await apiFetch(
        withPaging(`/api/bookings/handyman/${handymanId}`, page),
        {},
        true
      );
      dispatch(bookingActions.setBookingsPage(toPage(data)));
    } catch (e: any) {
      dispatch(bookingActions.setError(e.message));
    } finally {
      dispatch(bookingActions.endLoading());
    }
  };

export const acceptBooking =
  (bookingId: number): AppThunk =>
  async (dispatch) => {
    try {
      dispatch(bookingActions.startLoading());
      const data = await apiFetch(
        `/api/bookings/${bookingId}/accept`,
        { method: "PUT" },
        true
      );
      dispatch(bookingActions.upsertBooking(data));
    } catch (e: any) {
      dispatch(bookingActions.setError(e.message));
    } finally {
      dispatch(bookingActions.endLoading());
    }
  };

export const declineBooking =
  (bookingId: number): AppThunk =>
  async (dispatch) => {
    try {
      dispatch(bookingActions.startLoading());
      const data = await apiFetch(
        `/api/bookings/${bookingId}/decline`,
        { method: "PUT" },
        true
      );
      dispatch(bookingActions.upsertBooking(data));
    } catch (e: any) {
      dispatch(bookingActions.setError(e.message));
    } finally {
      dispatch(bookingActions.endLoading());
    }
  };

export const completeBooking =
  (bookingId: number): AppThunk =>
  async (dispatch) => {
    try {
      dispatch(bookingActions.startLoading());
      const data = await apiFetch(
        `/api/bookings/${bookingId}/complete`,
        { method: "PUT" },
        true
      );
      dispatch(bookingActions.upsertBooking(data));
    } catch (e: any) {
      dispatch(bookingActions.setError(e.message));
    } finally {
      dispatch(bookingActions.endLoading());
    }
  };

export const cancelBooking =
  (bookingId: number): AppThunk =>
  async (dispatch) => {
    try {
      dispatch(bookingActions.startLoading());
      const data = await apiFetch(
        `/api/bookings/${bookingId}/cancel`,
        { method: "PUT" },
        true
      );
      dispatch(bookingActions.upsertBooking(data));
    } catch (e: any) {
      dispatch(bookingActions.setError(e.message));
    } finally {
      dispatch(bookingActions.endLoading());
    }
  };
